import { handleServiceError } from '../helpers/app';
import apiRequest from './apiService';

const transferAgent = async (
  agentId: string,
  agentType: 'call' | 'chat',
  targetUserId: string,
  callerUserId: string
) => {
  try {
    const result = await apiRequest('admin', 'POST', '/agent/transfer_agent', {
      agent_id: agentId,
      agent_type: agentType,
      target_user_id: targetUserId,
      caller_user_id: callerUserId,
    });
    return result;
  } catch (error: any) {
    handleServiceError(error, 'agent');
  }
};

const adminService = { transferAgent };

export default adminService;
